const DatabaseLib = require('@/assets/js/DatabaseLib.js');

module.exports = async function(email, subject, content, token, redirectTo, attachments) {
    let base_url = "https://quadruscorp.net/login?redirect_to=";
    //let base_url = "https://dolc3g3gjvbc6.cloudfront.net/login?redirect_to=";
    //let base_url = "https://localhost:8085/login?redirect_to=";
    let link_url = "";

    let htmlContent = "<!DOCTYPE html><html><head><meta charset='UTF-8'><title>QCDB Databse</title></head>";
    htmlContent += "<body style='margin:0; padding:0;><table width='100%' cellpadding='0' cellspacing='0' border='0'>";
    htmlContent += "<tr><td align='center'><table width='100%'cellpadding='0'cellspacing='0'border='0'align='center'style='width:100%;margin:0 auto;>";
    htmlContent += "<tr><td align='center'><img src='https://quadruscorp.com/@resources/QCDBMessageLogo.png' alt='Header Image' width='100%'";
    htmlContent += "style='display:block; width:100%; height:auto; border:0; outline:none; text-decoration:none;'></td></tr>";
    htmlContent += "<tr><td style='padding:20px; calibri; font-size:16px;'><b>Do not reply.</b></td></tr>";
    htmlContent += "<tr><td style='padding:20px; calibri; font-size:16px;'><p style='font-family: calibri;'>" + content + "</p></td></tr>";
            
    if(redirectTo != ""){
      link_url = base_url + redirectTo;
      htmlContent += "<tr><td style='padding:20px;'><a href='" + link_url + "'>View</a></td></tr>";
    }
            
    htmlContent += "<tr><td style='padding:20px; calibri; font-size:16px;'><p style='font-family: calibri;'>If you have any questions, contact support at support@quadruscorp.com</p>";
    htmlContent += "<br><b>QCDB</b><br><b>Quadrus Corporation</b><br>690 Discovery Dr<br>Huntsville, AL 35806<br>Phone: 256-327-3410<br>E-mail: support@quadruscorp.com</td></tr>";
    htmlContent += "</table></td></tr></table></body></html>";

    let data = {
      to: email,
      subject: subject,
      html: htmlContent,
      files: attachments   
    }
    await DatabaseLib.postRequest('strapiDatabase','email/send-with-attachments',token,data);
}